import { localeStore } from '@/shared/i18n/locale-store';
import type { Locale } from '@/shared/i18n/locales';
import { daysBetween } from './days-between';
import type { IsoDate } from './iso-date';
import { today } from './today';

function unitOf(days: number): readonly [number, Intl.RelativeTimeFormatUnit] {
  const size = Math.abs(days);
  if (size < 45) return [days, 'day'];
  if (size < 730) return [Math.round(days / 30.44), 'month'];
  return [Math.round(days / 365.25), 'year'];
}

/** "today", "tomorrow", "in 12 days", "3 months ago"… in the locale, relative to `from`. */
export function formatRelative(
  date: IsoDate,
  from: IsoDate = today(),
  locale: Locale = localeStore.read(),
): string {
  const [amount, unit] = unitOf(daysBetween(from, date));
  return new Intl.RelativeTimeFormat(locale, { numeric: 'auto' }).format(amount, unit);
}
